import React, { useRef, useState } from "react"

import classNames from "@utils/classnames"

import * as styles from "./nav.module.scss"
import { getLocationInfo } from "@src/utils/location"
import Clickable from "../clickable"
import { workshopTypeText } from "@src/utils/view_helpers"
import Icon from "../icon"
import { useScrollEvent } from "@src/utils/hooks"
import { Link } from "gatsby"
import logoImg from "@images/logo.png"
import EnrollModal from "../enrollModal"

const Nav = React.memo(({ location }) => {
  const {
    inHomepage,
    inStreamingPage,
    inStreamingWorkshopPage,
    inStreamingMiniPage,
  } = getLocationInfo(location)
  const [enrollModalVisible, setEnrollModalVisible] = useState(false)
  const [dropdownVisble, setDropdownVisible] = useState(false)
  const [visible, setVisible] = useState(true)
  const prevScrollTopRef = useRef(-1)

  const handleItemClick = (e) => {
    setDropdownVisible(false)

    const t = e.currentTarget
    const id = t.getAttribute("href")
    const elem = document.querySelector(`#${id.split("#")[1]}`)

    if (!elem) {
      return
    }

    const headerOffset = 50
    const elementPosition = elem.getBoundingClientRect().top
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    })

    e.preventDefault()
  }

  useScrollEvent(() => {
    const scrollTop = window.scrollY
    const prevTop = prevScrollTopRef.current
    if (scrollTop <= 500) {
      setVisible(true)
      return
    }
    if (prevTop >= 0) {
      setVisible(scrollTop < prevTop)
    }
    prevScrollTopRef.current = scrollTop
  })

  return (
    <nav
      className={classNames(styles.nav, {
        [styles.streamingNav]: inStreamingWorkshopPage,
        [styles.streamingMiniNav]: inStreamingMiniPage,
        [styles.isDropdown]: dropdownVisble,
        [styles.isHide]: !visible,
      })}
    >
      <Clickable
        className={styles.dropDownMask}
        onClick={() => {
          setDropdownVisible(false)
        }}
      />
      <div className="container">
        <div className={styles.logoContainer}>
          <Link to="/">
            <img src={logoImg} className={styles.logo} alt="logo" />
            {/* <Icon icon="logo" className={styles.logo} /> */}
          </Link>
          {inStreamingPage && (
            <span>
              <b>|</b>
              <strong>
                {"" && workshopTypeText(inStreamingMiniPage)} 直播间
              </strong>
            </span>
          )}
        </div>
        <div className={styles.right}>
          <Clickable
            className={styles.menuBtn}
            onClick={() => {
              setDropdownVisible((prev) => !prev)
            }}
          >
            {dropdownVisble ? <Icon icon="close" /> : <Icon icon="burger" />}
          </Clickable>
          <div className={styles.menu}>
            <ul>
              {[
                { title: "介绍", href: "/#intro" },
                { title: "嘉宾", href: "/#guests" },
                {
                  title: "日程",
                  href: "/#flow",
                },
                // {
                //   title: "开发者中心",
                //   href: "/#dev",
                // },
              ].map(({ title, href }) => {
                return (
                  <li key={title}>
                    <Clickable
                      newWindow={false}
                      to={href}
                      onClick={handleItemClick}
                    >
                      {title}
                    </Clickable>
                  </li>
                )
              })}
            </ul>
            {inHomepage && (
              <div className={styles.menuActions}>
                <EnrollModal
                  isOpen={enrollModalVisible}
                  close={() => {
                    setEnrollModalVisible(false)
                  }}
                />
                <Clickable
                  onClick={() => {
                    setEnrollModalVisible(true)
                  }}
                  className={styles.enrollBtn}
                >
                  扫码预约
                </Clickable>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  )
})

export default Nav
